import { render, staticRenderFns } from "./MultiSelectView.vue?vue&type=template&id=68b27bd2&scoped=true"
import script from "./MultiSelectView.vue?vue&type=script&lang=js"
export * from "./MultiSelectView.vue?vue&type=script&lang=js"
import style0 from "./MultiSelectView.vue?vue&type=style&index=0&id=68b27bd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b27bd2",
  null
  
)

export default component.exports